import React, { useEffect } from 'react';
import styles from './FourthScreen.module.css';
import ScrollReveal from 'scrollreveal';
import Box from '../ReceptionistComponents/box/box';
import Button from '../ReceptionistComponents/button/Button';

// Importing icons
import moneyBagIcon from '../icons/wired-outline-414-money-bag-dollar-hover-shake.json';
import worldGlobeIcon from '../icons/wired-outline-735-world-globe-hover-roll.json';
import shieldSecurityIcon from '../icons/wired-outline-457-shield-security-hover-pinch.json';

const FourthScreenRec = () => {
  const icons = [moneyBagIcon, worldGlobeIcon, shieldSecurityIcon];

  const panels = [
    {
      icon: moneyBagIcon,
      title: 'ליהנות מרווחיות מקסימלית מהיום הראשון',
      description: 'בלי להסתבך עם מלאי, בלי לשלם שכירות מפוצצת על משרד ובלי כאב הראש של ניהול עובדים ומשכורות. כאן, כל שקל שנכנס לעסק מבוסס על המשאב הכי יקר שיש לך – המוח והזמן שלך.'
    },
    {
      icon: worldGlobeIcon,
      title: 'להשיג חופש גיאוגרפי מלא',
      description: 'ניהול דיגיטלי מקצה לקצה שמאפשר לך לעבוד מהבית (ליד הילדים), מהקפה השכונתי או מכל מקום בעולם. את מחליטה איפה המשרד שלך נמצא היום ואיך נראה הלו"ז שלך.'
    },
    {
      icon: shieldSecurityIcon,
      title: 'לבנות ביטחון מקצועי שמבוסס על מי שאת',
      description: 'את לא צריכה "להמציא את עצמך" מחדש. את פשוט לוקחת את היכולות הטבעיות שלך ורותמת אותן לקריירה שמתגמלת אותך בדיוק לפי הערך שאת מביאה.'
    }
  ];

  useEffect(() => {
    // ScrollReveal animations
    ScrollReveal().reveal(`.${styles.subtitle}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.finalTitle}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      delay: 200,
    });
  }, []);

  return (
    <section className={styles.container}>
      {/* שני האלמנטים מהמסך השלישי */}
      <p className={styles.subtitle}>
        וכשתהפכי את התשוקה שלך לעסק רווחי
      </p>

      <h3 className={styles.finalTitle}>
        תוכלי...
      </h3>

      {/* 3 פאנלים בעיצוב זכוכיתי */}
      <div className={styles.panelsGrid}>
        {panels.map((panel, index) => (
          <Box
            key={index}
            icon={panel.icon}
            title={panel.title}
            description={panel.description}
          />
        ))}
      </div>

      {/* כפתור בתחתית */}
      <div className={styles.buttonContainer}>
        <Button text="אני רוצה לשמוע עוד" />
      </div>
    </section>
  );
};

export default FourthScreenRec;
